import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/NotFound.vue'
import home from '@/components/pages/home.vue'
import newsDetail from '@/components/pages/news/news-detail.vue'
import profile from '@/components/pages/company/profile.vue'
// import group from '@/components/pages/company/group.vue'
import logisticsAutomation from '@/components/pages/solution/logistics-automation.vue'
import lowCode from '@/components/pages/solution/low-code.vue'
import service from '@/components/pages/service/service.vue'
// import projectDetail from '@/components/pages/service/project-detail.vue'
import recruit from '@/components/pages/recruit/recruit.vue'
import contactUs from '@/components/pages/contact/contact-us.vue'
import policy from '@/components/pages/policy/policy.vue'
import privacy from '@/components/pages/policy/privacy.vue'

// vueにvue-routerを使用するように伝える
Vue.use(Router)

const routes = [
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'NotFound'
    }
  },
  {
    name: 'home',
    path: '/',
    component: home,
    meta: {
      title: '',
      requireLogin: false
    }
  },
  {
    name: 'newsDetail',
    path: '/news/news-detail',
    component: newsDetail,
    meta: {
      title: 'お知らせ',
      requireLogin: false
    }
  },
  {
    name: 'profile',
    path: '/company/profile',
    component: profile,
    meta: {
      title: '会社概要',
      requireLogin: false
    }
  },
  // {
  //   name: 'group',
  //   path: '/company/group',
  //   component: group,
  //   meta: {
  //     title: 'グループ概要',
  //     requireLogin: false
  //   }
  // },
  {
    name: 'logisticsAutomation',
    path: '/solution/logistics-automation',
    component: logisticsAutomation,
    meta: {
      title: '物流自動化ソリューション',
      requireLogin: false
    }
  },
  {
    name: 'lowCode',
    path: '/solution/low-code',
    component: lowCode,
    meta: {
      title: 'Lowコードソリューション',
      requireLogin: false
    }
  },
  {
    name: 'service',
    path: '/service/index',
    component: service,
    meta: {
      title: 'サービス案内',
      requireLogin: false
    }
  },
  // {
  //   name: 'project-detail',
  //   path: '/service/project-detail',
  //   component: projectDetail,
  //   meta: {
  //     title: '実績詳細',
  //     requireLogin: false
  //   }
  // },
  {
    name: 'recruit',
    path: '/recruit/index',
    component: recruit,
    meta: {
      title: '採用情報',
      requireLogin: false
    }
  },
  {
    name: 'contactUs',
    path: '/contact/index',
    component: contactUs,
    meta: {
      title: 'お問い合わせ',
      requireLogin: false
    }
  },
  {
    name: 'policy',
    path: '/policy',
    component: policy,
    meta: {
      title: 'サイトポリシー',
      requireLogin: false
    }
  },
  {
    name: 'privacy',
    path: '/privacy',
    component: privacy,
    meta: {
      title: 'プライバシーポリシー',
      requireLogin: false
    }
  }
]

var router = new Router({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {

  let title = "株式会社ロボティクスソリューションズ"
  if (to.meta.title) {
    document.title = `${title} | ${to.meta.title}`
  } else {
    document.title = title
  }

  window.scrollTo(0, 0);
  let l = $('body')
  let a = $(".st-Hd_Trigger-bg").parent()

  if (from.path !== '/') { $('.st-Hd_Logo_Img').attr('src', '../../../static/img/logo/logo-black.png') }
  if (a.hasClass('is-active')) {
    a.removeClass('is-active')
    l.removeClass('is-sp-open')
    $('.st-Nav_List-en').css({ 'color': '#222' })
  }
  next();
})

// let isOperator = path => {
//   if (path.search(/^\/operator\//) !== -1) return 'operatorlogin'
//   else return 'login'
// }

// トークンチェック
// router.beforeEach((to, from, next) => {
//   // const { meta } = to
//   // const { requireLogin } = meta
//   // let tokenId = Cookies.get('tokenId')
//   // const needLogin = requireLogin && (tokenId == null || tokenId === '')

//   // if (needLogin) {
//   //   return next({
//   //     name: isOperator(to.path),
//   //     params: {
//   //       nextUrl: to.fullPath
//   //     }
//   //   })
//   // }

//   // キャッシュしなし、リフレッシュする
//   to.meta.keepAlive = false
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js